<template>
<div class="chapter">
<div class="inner_page">
<h2 class="toc-title"><a id="page_3"></a>Contents</h2>
<h2 class="toc"><a href="#/xhtml/07_Introduction#int">Introduction</a></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter_01#ch1" title="Link target outside of Sample">Materials, tools and techniques</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter_02#ch2" title="Link target outside of Sample">Flower</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter_03#ch3" title="Link target outside of Sample">Paisley</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter_04#ch4" title="Link target outside of Sample">Boho Toggle</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter_05#ch5" title="Link target outside of Sample">Envelope Toggle</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter_06#ch6" title="Link target outside of Sample">Dotted Singleton</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter_07#ch7" title="Link target outside of Sample">Kelly</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter_08#ch8" title="Link target outside of Sample">Bow</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter_09#ch9" title="Link target outside of Sample">Trinket</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter_10#ch10" title="Link target outside of Sample">Rivet</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter_11#ch11" title="Link target outside of Sample">Sunshine</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter_12#ch12" title="Link target outside of Sample">Pod</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter_13#ch13" title="Link target outside of Sample">Bottle-top</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter_14#ch14" title="Link target outside of Sample">Garden</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Chapter_15#ch15" title="Link target outside of Sample">Cushion</span></h2>
<h2 class="toc"><span href="#/xhtml/23_Chapter_16#ch16" title="Link target outside of Sample">Crown</span></h2>
<h2 class="toc"><span href="#/xhtml/24_Chapter_17#ch17" title="Link target outside of Sample">Shell</span></h2>
<h2 class="toc"><span href="#/xhtml/25_Chapter_18#ch18" title="Link target outside of Sample">Wrapped Up</span></h2>
<h2 class="toc"><span href="#/xhtml/26_Chapter_19#ch19" title="Link target outside of Sample">‘X’ Marks the Spot</span></h2>
<h2 class="toc"><span href="#/xhtml/27_Chapter_20#ch20" title="Link target outside of Sample">Spiral</span></h2>
<h2 class="toc"><span href="#/xhtml/28_Chapter_21#ch21" title="Link target outside of Sample">Laced Up</span></h2>
<h2 class="toc"><span href="#/xhtml/29_Author#aut" title="Link target outside of Sample">Author’s note</span></h2>
<div class="image_container">
<img alt="images" src="images/img_002-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?9a7859ca